import { render, staticRenderFns } from "./identicon.vue?vue&type=template&id=22e1871c&"
import script from "./identicon.vue?vue&type=script&lang=js&"
export * from "./identicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports